module.exports = __webpack_public_path__ + "static/media/logo-axis.bca19767.svg";